import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;
  Components.addType("courier-branch-list", {
    model: {
      defaults: {
        draggable: true,
        droppable: false,
        components: html`
          <section class="py-6 container mx-auto px-4">
            <div class="flex flex-wrap justify-between items-start mb-4 gap-4">
              <div class="flex flex-col">
                <input
                  id="searchInput"
                  type="text"
                  placeholder="Search Destination..."
                  class="border-1 px-4 py-2 rounded border-gray-300 focus:outline-none focus:border-gray-500 transition w-64"
                />
              </div>

              <div class="flex items-center gap-2">
                <select
                  id="branchSelect"
                  class="border px-4 py-2 rounded text-gray-700"
                >
                  <option value="">Search branch</option>
                </select>
                <button
                  class="bg-red-600 text-white px-6 py-2 rounded cursor-pointer"
                  id="downloadBtn"
                >
                  Download
                </button>
              </div>
            </div>

            <div class="overflow-x-auto">
              <table class="min-w-full   text-sm text-left" id="branchTable">
                <thead>
                  <tr class="bg-red-600 text-white">
                    <th class="px-4 py-2 ">S.No</th>
                    <th class="px-4 py-2 ">Destination</th>
                    <th class="px-4 py-2 ">District</th>
                    <th class="px-4 py-2 ">State</th>
                    <th class="px-4 py-2 ">Delivery Charge</th>
                  </tr>
                </thead>
                <tbody id="tableBody"></tbody>
              </table>
            </div>
            <div class="flex justify-between items-center mt-4">
              <div class="flex items-center gap-2">
                <button
                  id="prevBtn"
                  class="px-2 py-1 border rounded"
                  onClick="prevPage()"
                >
                  &lt;
                </button>
                <button
                  id="nextBtn"
                  class="px-2 py-1 border rounded"
                  onClick="nextPage()"
                >
                  &gt;
                </button>
                <span id="pageInfo">Page 1 of 1</span>

                <div>
                  Show
                  <select id="items" class="border px-2 py-1 rounded ml-1">
                    <option value="10" selected>10</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                  </select>
                </div>
              </div>
            </div>
          </section>
        `,
        script: function () {
          const tableBody = this.querySelector("#tableBody");
          const searchInput = this.querySelector("#searchInput");
          const downloadBtn = this.querySelector("#downloadBtn");
          const itemsPerPageSelect = this.querySelector("#items");
          const prevBtn = this.querySelector("#prevBtn");
          const nextBtn = this.querySelector("#nextBtn");
          const pageInfo = this.querySelector("#pageInfo");
          const branchSelect = this.querySelector("#branchSelect");

          let currentPage = 1;
          let itemsPerPage = parseInt(itemsPerPageSelect?.value || "10");
          let originalData = [];

          function generateCSVFromTable(table) {
            let csv = "";
            const rows = table.querySelectorAll("tr");

            rows.forEach((row) => {
              const cols = row.querySelectorAll("td, th");
              const rowData = [];
              cols.forEach((col) => {
                const text = col.textContent?.trim().replace(/"/g, '""') || "";
                rowData.push(`"${text}"`);
              });
              csv += rowData.join(",") + "\n";
            });

            return csv;
          }

          function downloadCSV(csv, filename) {
            const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.setAttribute("href", url);
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }

          function filterData() {
            const keyword = searchInput?.value?.toLowerCase() || "";
            return originalData.filter(
              (branch) =>
                branch.service_city?.toLowerCase().includes(keyword) ||
                branch.district?.toLowerCase().includes(keyword) ||
                branch.state?.toLowerCase().includes(keyword)
            );
          }

          function renderTable() {
            const filteredData = filterData();
            const start = (currentPage - 1) * itemsPerPage;
            const end = start + itemsPerPage;
            const paginatedData = filteredData.slice(start, end);

            tableBody.innerHTML = "";

            if (paginatedData.length === 0) {
              tableBody.innerHTML = `<tr><td colspan="5" class="px-4 py-2 text-gray-500">No data found.</td></tr>`;
              pageInfo.textContent = `Page 0 of 0`;
              return;
            }

            paginatedData.forEach((branch, index) => {
              const row = document.createElement("tr");
              row.className = index % 2 === 0 ? "bg-gray-100" : "bg-gray-200";

              row.innerHTML = `
        <td class="px-4 py-2">${start + index + 1}</td>
        <td class="px-4 py-2">${branch.service_city}</td>
        <td class="px-4 py-2">${branch.district}</td>
        <td class="px-4 py-2">${branch.state}</td>
        <td class="px-4 py-2">${branch.rate}</td>
      `;

              tableBody.appendChild(row);
            });

            const totalPages = Math.ceil(filteredData.length / itemsPerPage);
            pageInfo.textContent = `Page ${currentPage} of ${totalPages}`;
            prevBtn.disabled = currentPage === 1;
            nextBtn.disabled = currentPage === totalPages;
          }

          function fetchBranches() {
            fetch(
              "https://apiservice.careinfosolutions.com/apiservice/api/v1/public/branch/"
            )
              .then((res) => res.json())
              .then((data) => {
                data.forEach((branch) => {
                  const option = document.createElement("option");
                  option.value = branch.id;
                  option.textContent = branch.name;

                  if (branch.id === "a5e2f275-0561-4344-84b6-84e932d45ea6") {
                    option.selected = true;
                  }

                  branchSelect.appendChild(option);
                });

                fetchBranchData("a5e2f275-0561-4344-84b6-84e932d45ea6");
              })
              .catch((err) => {
                console.error("Failed to fetch branches", err);
              });
          }

          function fetchBranchData(branchId) {
            fetch(
              `https://apiservice.careinfosolutions.com/apiservice/api/v1/public/branch-delivery-charge/?pickup_branch=${branchId}`
            )
              .then((res) => res.json())
              .then((data) => {
                originalData = data || [];
                currentPage = 1;
                renderTable();
              })
              .catch((err) => {
                console.error("Failed to fetch delivery charge data", err);
                tableBody.innerHTML = `<tr><td colspan="5" class="px-4 py-2 text-red-500">Failed to load data.</td></tr>`;
              });
          }

          fetchBranches();
          branchSelect?.addEventListener("change", (e) => {
            const selectedBranchId = e.target.value;
            if (selectedBranchId) {
              fetchBranchData(selectedBranchId);
            } else {
              originalData = [];
              renderTable();
            }
          });

          downloadBtn?.addEventListener("click", () => {
            const csv = generateCSVFromTable(tableBody);
            downloadCSV(csv, "branch-data.csv");
          });

          searchInput?.addEventListener("input", () => {
            currentPage = 1;
            renderTable();
          });

          itemsPerPageSelect?.addEventListener("change", (e) => {
            itemsPerPage = parseInt(e.target.value);
            currentPage = 1;
            renderTable();
          });

          prevBtn?.addEventListener("click", () => {
            if (currentPage > 1) {
              currentPage--;
              renderTable();
            }
          });

          nextBtn?.addEventListener("click", () => {
            const totalPages = Math.ceil(filterData().length / itemsPerPage);
            if (currentPage < totalPages) {
              currentPage++;
              renderTable();
            }
          });
        },
      },
    },
  });
};
